import { Component } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import * as moment from "moment";

@Component({
    selector: "app-fecha-certificacion-modal",
    templateUrl: "./fecha-certificacion-modal.component.html",
})
export class FechaCertificacionModalComponent {
    public readonly fechaMinima = moment().format("YYYY-MM-DD");
    public fechaCertificacion = this.fechaMinima;

    constructor(public activeModal: NgbActiveModal) {}

    get fechaCertificacionValida(): boolean {
        const fecha = moment(this.fechaCertificacion, "YYYY-MM-DD", true);
        return fecha.isValid() && !fecha.isBefore(moment(), "day");
    }

    confirmar(): void {
        if (!this.fechaCertificacionValida) return;
        this.activeModal.close(moment(this.fechaCertificacion, "YYYY-MM-DD", true).toDate());
    }
}
